import { Kanban, List } from "lucide-react";
import { useTodoStore } from "../store/todoStore";

export function ViewToggle() {
  const { viewMode, setViewMode } = useTodoStore();

  return (
    <div className="flex items-center gap-1 p-1 bg-muted rounded-lg">
      <button
        type="button"
        onClick={() => setViewMode("list")}
        className={`
                    flex items-center gap-2 px-3 py-1.5 rounded-md text-sm font-medium
                    transition-all duration-200
                    ${
                      viewMode === "list"
                        ? "bg-background text-foreground shadow-sm"
                        : "text-muted-foreground hover:text-foreground"
                    }
                `}
        aria-label="列表视图"
      >
        <List size={16} />
        <span>列表</span>
      </button>
      <button
        type="button"
        onClick={() => setViewMode("kanban")}
        className={`
                    flex items-center gap-2 px-3 py-1.5 rounded-md text-sm font-medium
                    transition-all duration-200
                    ${
                      viewMode === "kanban"
                        ? "bg-background text-foreground shadow-sm"
                        : "text-muted-foreground hover:text-foreground"
                    }
                `}
        aria-label="看板视图"
      >
        <Kanban size={16} />
        <span>看板</span>
      </button>
    </div>
  );
}
